import {_, React, observer, observable, computed, action, useLocalStore, classNames} from '@api'
import {Switch} from '@material-ui/core'
import {makeStyles, Theme, createStyles} from '@material-ui/core/styles'
import {} from '@blueprintjs/core'
import {SwitchProps} from '@material-ui/core/Switch/Switch'
import {} from '@stores'
import {} from '@modules'
import * as css from './SmallSwitch.css'

/// region Store

export class SmallSwitchStore {
  constructor() {
  }

  @observable mustHaveAtLeastOneObservable = true
}

export const SmallSwitchStoreContext = React.createContext<SmallSwitchStore>(null)
export const useSmallSwitchStore = () => React.useContext(SmallSwitchStoreContext)

/// endregion

/// region Components

interface MyProps extends SwitchProps {
  className?: string
}

export const SmallSwitch = observer<MyProps>(function SmallSwitch({className, ...props}) {
  const store = null // useLocalStore(() => new SmallSwitchStore())

  return (
    <SmallSwitchStoreContext.Provider value={store}>
      <Switch
        className={classNames(css.root, className)}
        classes={{
          switchBase: css.switchBase,
          thumb: css.thumb
        }}
        {...props}
        color='secondary'
        size='small'
      />
    </SmallSwitchStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/shared/components/ui/components/SmallSwitch.tsx